import React, { useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { Toast } from "primereact/toast";
import NavbarCustom from "../../Components/NavbarCustom";
import { usePlayerAccount } from "../../APIContext/PlayerAccountContext";
import { useParent } from "../../APIContext/ParentContext";
import { useMOU } from "../../APIContext/MOUContext";
import DefaultImage from "../../Assets/Images/child.png";
import PenIcon from "../../Assets/Icons/PenIcon";
import "./addchildform.css";
import { useNavigate, useLocation } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import Swal from "sweetalert2";

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const gradeList = [
  { label: "Kindergarten", value: "Kindergarten" },
  { label: "1st", value: "1st" },
  { label: "2nd", value: "2nd" },
  { label: "3rd", value: "3rd" },
  { label: "4th", value: "4th" },
  { label: "5th", value: "5th" },
  { label: "6th", value: "6th" },
  { label: "7th", value: "7th" },
  { label: "8th", value: "8th" },
  { label: "High School", value: "High School" },
  { label: "College", value: "College" },
  { label: "Professional", value: "Professional" },
];

const AddChildForm = () => {
  const toast = useRef(null);
  const navigate = useNavigate();
  const { createPlayer } = usePlayerAccount();
  const { fetchLSParentDetails } = useParent();
  const { checkMOUStatus } = useMOU();
  const [profilePicture, setProfilePicture] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);
  const fileInputRef = useRef(null);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const packageId = queryParams.get("id");

  const userData = JSON.parse(localStorage.getItem("user"));

  const [form, setForm] = useState({
    name: "",
    date_of_birth: null,
    age: "",
    grade: "",
    jersey_size: "",
    school_name: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (e) => {
    const dob = e.value;
    const today = new Date();
    const age =
      today.getFullYear() -
      dob.getFullYear() -
      (today.getMonth() < dob.getMonth() ||
      (today.getMonth() === dob.getMonth() && today.getDate() < dob.getDate())
        ? 1
        : 0);

    setForm((prev) => ({
      ...prev,
      date_of_birth: dob,
      age: age.toString(),
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fieldNames = {
      name: "Name",
      date_of_birth: "Date of Birth",
      age: "Age",
      grade: "Grade",
      jersey_size: "Jersey Size",
      school_name: "School Name",
    };

    const missingFields = [];

    for (const [key, value] of Object.entries(form)) {
      if (value === "" || value === null) {
        missingFields.push(fieldNames[key]);
      }
    }

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: `Missing Fields`,
        text: `Please enter: ${missingFields.join(", ")}`,
        confirmButtonColor: "#B79527",
      });
      return;
    }

    if (!form.date_of_birth) {
      Swal.fire({
        icon: "warning",
        title: "Missing Date of Birth",
        text: "Please select your child's date of birth.",
        confirmButtonColor: "#B79527",
      });
      return;
    }

    setIsDisabled(true);
    let payload;

    if (profilePicture) {
      payload = new FormData();

      Object.entries(form).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          const isDate = value instanceof Date;
          payload.append(
            key,
            isDate ? value.toISOString().split("T")[0] : value.toString(),
          );
        }
      });

      payload.append("profile_picture", profilePicture);

      // for (let pair of payload.entries()) {
      //   console.log(`${pair[0]}:`, pair[1]);
      // }
    } else {
      payload = {
        ...form,
        date_of_birth: form.date_of_birth
          ? form.date_of_birth.toISOString().split("T")[0]
          : null,
      };
    }

    const result = await createPlayer(payload);

    if (result.success && result.data.payload) {
      await fetchLSParentDetails();

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: `${result.data.message}`,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });

      let mouStatus = await checkMOUStatus(result.data.payload.id);

      if (mouStatus.status === "no_mou" && userData.is_self_pay === false) {
        Swal.fire({
          icon: "info",
          title: "Information",
          text: `${mouStatus.message}`,
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });

        navigate("/mou-form?player_id=" + result.data.payload.id);
        setIsDisabled(false);
        return;
      } else {
        setTimeout(() => {
          setIsDisabled(false);
          if (packageId) {
            navigate("/add-a-child?id=" + packageId);
          } else {
            navigate("/add-a-child");
          }
        }, 2000);
        return;
      }
    } else {
      setIsDisabled(false);
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: `Failed to add a child!`,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <NavbarCustom />
      <div className="add-child-container add-child-form-container">
        <div className="add-child-header">
          <BackBtn />
          <div className="add-child-header-content">
            <h1 className="add-child-heading black-text-clip">Add Another Child</h1>
            <p className="black-text-clip">Fill out the information of your Child</p>
          </div>
        </div>

        <div className="add-child-form-container content">
          <form onSubmit={handleSubmit}>
            <div className="add-child-form-wrapper">
              <div className="profile-ele">
                <div className="profile-image">
                  <div className="img-container">
                    <img
                      src={
                        profilePicture
                          ? URL.createObjectURL(profilePicture)
                          : DefaultImage
                      }
                      alt="Profile"
                    />
                    <span
                      className="pen-icon-overlay"
                      onClick={() => fileInputRef.current?.click()}
                      style={{ cursor: "pointer" }}
                    >
                      <PenIcon />
                    </span>
                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={fileInputRef}
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setProfilePicture(e.target.files[0]);
                        }
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="add-child-form-fields">
                <div className="form-group">
                  <InputText
                    placeholder="Full Name"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <Calendar
                    placeholder="Date of Birth"
                    value={form.date_of_birth}
                    onChange={handleDateChange}
                    showIcon
                    dateFormat="yy-mm-dd"
                    className="calesndr-cstm"
                  />
                </div>

                <div className="form-group">
                  <InputText
                    placeholder="Age"
                    name="age"
                    value={form.age}
                    readOnly
                  />
                </div>

                <div className="form-group jersey-size-dropdown">
                  <Dropdown
                    value={form.grade}
                    options={gradeList}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        grade: e.value,
                      }))
                    }
                    placeholder="Select Grade"
                  />
                </div>

                <div className="form-group jersey-size-dropdown">
                  <Dropdown
                    value={form.jersey_size}
                    options={jerseySizes}
                    onChange={(e) =>
                      setForm((prev) => ({
                        ...prev,
                        jersey_size: e.value,
                      }))
                    }
                    placeholder="Select Jersey Size"
                  />
                </div>

                <div className="form-group">
                  <InputText
                    placeholder="School Name"
                    name="school_name"
                    value={form.school_name}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="add-child-submit-button">
              <button
                type="submit"
                className="p-submit-button add-child-btn"
                disabled={isDisabled}
                style={
                  isDisabled
                    ? { cursor: "not-allowed", background: "rgb(0 0 0 / 78%)" }
                    : {}
                }
              >
                {isDisabled ? "Processing..." : "Proceed"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddChildForm;
